import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {
  autoScrollOnFocus: false,
});


import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import axios from 'axios'
Vue.prototype.axios = axios;
import api from '@/api/api'
Vue.prototype.$api = api;

import $ from 'jquery'
Vue.prototype.$ = $


import '@/assets/style/base.css'
import '@/assets/style/common.css'


import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css';

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  }
})
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})


import './assets/icons/index'


// import MathLive from "./utils/mathlive.mjs";
// import * as MathLive from './utils/mathlive.mjs';
// import Mathfield from "./utils/vue-mathlive.mjs";

// Vue.use(Mathfield, MathLive);

// import {
//   MathfieldElement
// } from './utils/mathlive.mjs';

import {
  NewToast
} from "@/components/Toast/index";
Vue.use(NewToast);


// import MathJax from '@/utils/globalVariable'
// Vue.prototype.MathJax = MathJax
import globalVariable from '@/utils/globalVariable'
Vue.prototype.commonsVariable = globalVariable;


import '@/utils/filters/index'


import VueCropper from 'vue-cropper'

Vue.use(VueCropper)



import MathJax from '@/utils/MathJax.js'
Vue.prototype.$MathJax = MathJax
// Vue.prototype.$baseURL = 'http://192.168.100.212:8600';
// Vue.prototype.$baseURL = 'http://192.168.100.214:8600';
// Vue.prototype.$baseURL = 'http://192.168.66.99:8600';
Vue.prototype.$baseURL = window.location.origin + '/api';
// Vue.prototype.$baseURL = "https://chatlearning.newacademic.net/api";
new Vue({
  axios,
  router,
  store,
  // MathfieldElement,

  render: h => h(App)
}).$mount('#app')